import React from "react";

const Select = React.forwardRef(
  ({ className = "", children, ...props }, ref) => (
    <select
      ref={ref}
      className={`border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-500 ${className}`}
      {...props}
    >
      {children}
    </select>
  )
);

export default Select;
